import { TableRow, TableRowProps } from '@mui/material'
import { observer } from 'mobx-react'
import React, { FC, PropsWithChildren } from 'react'

type ITableRowProps = TableRowProps &
  PropsWithChildren & {
    outline?: boolean
  }

const NewTableRow: FC<ITableRowProps> = ({
  children,
  outline,
  onClick,
  ...otherProps
}) => {
  return (
    <TableRow
      className={'fx-nowrap'}
      sx={{
        height: outline ? '46px' : null,
        outline: outline
          ? '5px solid rgba(93, 175, 239, 0.3) !important'
          : 'none',
        position: 'relative',
        zIndex: outline ? 10 : 1,
        '&:hover': onClick
          ? {
              backgroundColor: 'rgba(93, 175, 239, 0.20)!important',
              cursor: 'pointer',
            }
          : {},
      }}
      onClick={onClick}
      {...otherProps}
    >
      {children}
    </TableRow>
  )
}

export default observer(NewTableRow)
